export default function(message) {
  throw Error(message);
}



//////////////////
// WEBPACK FOOTER
// ./~/vega-util/src/error.js
// module id = 868
// module chunks = 0